import React, { Component } from 'react';

export default class UltimosSucesos extends Component {

    render() {
        return (
            <div className="gray-bg" id="ultimos-sucesos">
                        <div className="boletin__section">
                          <div className="row boletin__title-row">
                            <div className="col-sm-12  boletin__title-name-section">
                              <span className=" boletin__title-name">ÚLTIMOS SUCESOS</span>
                            </div>
                          </div>

                          <div className="timeline-events-web">
                              <ul className="timeline-horizontal ">
                                  <li className="timeline-item">
                                    <div className="timeline-item__description">
                                        <div className="text-center timeline-item__text">Cae el precio del algodón</div>
                                      </div>
                                    <div className="timeline-item__date-section">
                                      <span className="timeline-item__date">15/09<p></p>
                                    </span></div>
                                  </li>

                                  <li className="timeline-item">
                                      <div className="timeline-item__description">
                                          <div className="text-center timeline-item__text timeline-item__text--highlight">Zara abre fábrica en Lima</div>
                                        </div>
                                      <div className="timeline-item__date-section">
                                        <span className="timeline-item__date">15/09<p></p>
                                      </span></div>
                                    </li>

                                  <li className="timeline-item">
                                      <div className="timeline-item__description">
                                          <div className="text-center timeline-item__text">Acuerdo comercial entre Pepe y Juan</div>
                                        </div>
                                      <div className="timeline-item__date-section">
                                        <span className="timeline-item__date">15/09<p></p>
                                      </span></div>
                                    </li>

                                  <li className="timeline-item">
                                      <div className="timeline-item__description">
                                          <div className="text-center timeline-item__text">Acuerdo comercial entre Pepe y Juan</div>
                                        </div>
                                      <div className="timeline-item__date-section">
                                        <span className="timeline-item__date">15/09<p></p>
                                      </span></div>
                                    </li>

                                  <li className="timeline-item">
                                      <div className="timeline-item__description">
                                          <div className="text-center timeline-item__text timeline-item__text--highlight">Feria de innovación en tejidos en Arequipa</div>
                                        </div>
                                      <div className="timeline-item__date-section">
                                        <span className="timeline-item__date">15/09<p></p>
                                      </span></div>
                                    </li>

                                  <li className="timeline-item">
                                      <div className="timeline-item__description">
                                          <div className="text-center timeline-item__text">Sube el arancel de Alemania para prendas de vestir</div>
                                        </div>
                                      <div className="timeline-item__date-section">
                                        <span className="timeline-item__date">15/09<p></p>
                                      </span></div>
                                    </li>
                                    <li className="timeline-item">
                                      <div className="timeline-item__description">
                                          <div className="text-center timeline-item__text">Cae el precio del algodón</div>
                                        </div>
                                      <div className="timeline-item__date-section">
                                        <span className="timeline-item__date">15/09<p></p>
                                      </span></div>
                                    </li>
                                    <li className="timeline-item">
                                      <div className="timeline-item__description">
                                          <div className="text-center timeline-item__text">Cae el precio del algodón</div>
                                        </div>
                                      <div className="timeline-item__date-section">
                                        <span className="timeline-item__date">15/09<p></p>
                                      </span></div>
                                    </li>
                              </ul> 
                          </div>

                          <div className="timeline-events-mobile">
                              <ul className="timeline-vertical">
                                  <li className="event" data-date="15/09">
                                      <p className="timeline-item__text">Cae el precio del algodón</p>
                                  </li>
                                  <li className="event" data-date="20/10">
                                      <p className="timeline-item__text timeline-item__text--highlight">Zara abre fábrica en Lima</p>
                                  </li>
                                  <li className="event" data-date="21/11">
                                      <p className="timeline-item__text">Acuerdo comercial entre Pepe y Juan</p>
                                  </li>
                                </ul>
                          </div>

                        </div>
                      </div>
        )}
}